import { defineStore } from "pinia";

export const BRAND_TAG = "?brandcid=EXPEDIA.ISHOWSPEED.MICROSITE";

const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_id",
    "utm_term",
    "utm_content",
];

function getCountryCookie() {
    if (typeof document === "undefined") return null;
    const match = document.cookie
        .split("; ")
        .find((row) => row.startsWith("country="));
    if (!match) return null;
    const value = decodeURIComponent(match.split("=")[1] ?? "").toUpperCase();
    return value || null;
}

function getUtmQuery() {
    if (typeof window === "undefined") return "";
    const params = new URLSearchParams(window.location.search);
    const parts = [];
    for (const key of UTM_KEYS) {
        const raw = params.get(key);
        if (!raw) continue;
        const sanitised = raw.slice(0, 200).replace(/[^\w.\- ]/g, "");
        if (!sanitised) continue;
        parts.push(`${key}=${encodeURIComponent(sanitised)}`);
    }
    return parts.length ? `&${parts.join("&")}` : "";
}

export const useExpediaStore = defineStore("expedia", {
    state: () => ({
        domains: [],
        loaded: false,
        utmQuery: "",
    }),

    getters: {
        localisedDomain(state) {
            if (!state.loaded || !state.domains.length) return null;
            const code = getCountryCookie();
            const match = code
                ? state.domains.find((d) => d.country?.code_a2 === code)
                : null;
            const fallback = state.domains.find(
                (d) => d.country?.code_a2 === "US",
            );
            return (match ?? fallback)?.url ?? null;
        },
    },

    actions: {
        setup() {
            this.utmQuery = getUtmQuery();
            return axios
                .get("/api/expedia/domains")
                .then((res) => {
                    this.domains = res.data;
                    this.loaded = true;
                })
                .catch((err) => console.error(err));
        },

        href(path) {
            if (!this.localisedDomain) return "";
            return `https://${this.localisedDomain}/${path}${BRAND_TAG}${this.utmQuery}`;
        },
    },
});
